import React from "react";

export const AdminLogin = React.lazy(() => import("./Login/index.page"));
export const AdminForgotPassword = React.lazy(() =>
  import("./ForgotPassword/index.page")
);
export const AdminOtpVerification = React.lazy(() =>
  import("./OtpVerification/index.page")
);
export const AdminResetPassword = React.lazy(() =>
  import("./ResetPassword/index.page")
);
export const AdminProfile = React.lazy(() =>
  import("./AdminAccount/AdminProfile/index.page")
);
export const AdminChangePassword = React.lazy(() =>
  import("./AdminAccount/AdminChangePassword/index.page")
);
export const AdminNotifications = React.lazy(() =>
  import("./AdminAccount/AdminNotifications/index.page")
);
export const AdminDashboard = React.lazy(() =>
  import("./Dashboard/index.page")
);
export const ManageUser = React.lazy(() =>
  import("./ManageUser/UserList/index")
);
export const UserDetails = React.lazy(() =>
  import("./ManageUser/UserDetails/index")
);
export const ManageSubscription = React.lazy(() =>
  import("./ManageSubscription/index")
);
export const TransactionHistory = React.lazy(() =>
  import("./TransactionHistory/index")
);
export const ReportCategory = React.lazy(() =>
  import("./ReportCategory/index")
);
export const ManageSupport = React.lazy(() => import("./ManageSupport/index"));
export * from "./ManageBiographies";
export * from "./ManageCms";
export * from "./ManageCoupen";
